enum CtaBtnAlignment {
  TOP_CENTER = 'btn-top-center-alignment',
  CENTER = 'btn-center-alignment',
  BOTTOM_CENTER = 'btn-bottom-center-alignment',
}
export { CtaBtnAlignment };
